import React from 'react'

export const UpdatePost = React.createContext();